module.exports = __webpack_public_path__ + "img/mastercard.4d8f23ba.svg";